import createSolidComponent from '../createSolidComponent';
export default createSolidComponent('outline', 'brand-thingiverse', 'BrandThingiverse', [["path",{"d":"M3 12a9 9 0 1 0 18 0a9 9 0 1 0 -18 0"}],["path",{"d":"M8 9h8m-4 0v8"}]]);